import { useState, useEffect, useRef } from "react";
import "../styling/Account.css";
import { FaUpload } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";
import axios from "axios";
import { useProfile } from "../ProfileContext";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; 
import { logout, updateUser } from "../authSlice";

const AccountInfo = ({ onClickAccountInfoButton, initialSelected }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const id = user?.id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVerified, setIsVerified] = useState(true);

  useEffect(() => {
    const fetchBusinessUserInfo = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/business-user`,
          { withCredentials: true }
        );
        setData(res?.data.data);
      } catch (err) {
        console.error("Error fetching business user info:", err);
        setError(err.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchBusinessUserInfo();
    }
  }, [id]);

  const [selectedButton, setSelectedButton] = useState(initialSelected);
  const { profileImage, setProfileImage } = useProfile(); // Use the shared context
  const accountProfileRef = useRef(null);

  useEffect(() => {
    setSelectedButton(initialSelected);
  }, [initialSelected]);

  const handleAccountProfileButtonClick = () => {
    // Programmatically click the hidden file input
    accountProfileRef.current.click();
  };
  const handleAccountProfileImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profilePic", file);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/upload-profile`,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setProfileImage(response.data.profilePic);
    } catch (error) {
      console.error("Error uploading profile image:", error);
    }
  };
  const handleButtonClick = (buttonType) => {
    setSelectedButton(buttonType);
    onClickAccountInfoButton(buttonType); // Send data to parent
  };

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (data) {
      setFormData({
        name: data?.name,
        lastName: data?.lastName,
        email: data?.email,
        phone: data?.phone,
      });
      setIsVerified(data?.verified);
    }
  }, [data]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  

  const handleSave = async () => {
    try {
      const currentEmail = (user?.email || "").trim().toLowerCase();
      const inputEmail = (formData.email || "").trim().toLowerCase();
      const isEmailChanged = inputEmail !== "" && inputEmail !== currentEmail;
  
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/update-business-user`, 
        { ...formData }, // FIX: Spread formData here instead of wrapping it in { formData }
        { withCredentials: true }
      );
  
      if (res.status === 200) {
        const updatedUser = res.data.user;
        
        if (updatedUser) {
          dispatch(updateUser(updatedUser)); 
          
          // Keep the input field showing the ACTIVE email
          setFormData(prev => ({
            ...prev, 
            email: updatedUser.email || prev.email 
          }));
        }
  
        if (isEmailChanged) {
          alert(`Verification email sent to ${inputEmail}. Please check your inbox.`);
        } else {
          alert("Details updated successfully.");
        }
      }
    } catch (err) {
      alert(err.response?.data?.error || "Update failed");
    }
  };

  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleResendLink = async () => {
    try {
      // Trigger your existing SendGrid link logic
      await axios.post(`${process.env.REACT_APP_API_URL}/business-user/resend-verification`, { email: user.pendingEmail });
      alert("Verification link resent successfully!");
    } catch (err) {
      alert("Error sending verification link.");
    }
  };

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/business-user/change-password`,
        {
          currentPassword,
          newPassword,
        },
        { withCredentials: true }
      );
      alert("Password changed successfully");
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Failed to change password");
    }
  };



    const [password, setPassword] = useState("");
  const [confirmDeletePassword, setConfirmDeletePassword] = useState("");

 const handleDelete = async () => {
  if (!password || !confirmDeletePassword) {
    alert("Please enter both password fields.");
    return;
  }

  if (password !== confirmDeletePassword) {
    alert("Passwords do not match.");
    return;
  }

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/business-user/delete-account`,
      {
        data: { password }, 
        withCredentials: true, 
      }
    );

    alert("Account deleted successfully.");
    navigate("/login");
  } catch (error) {
    alert(
      error?.response?.data?.message || "Failed to delete account. Try again."
    );
  }
};


  return (
    <div className="account-wrapper" style={{ marginTop : "20px"}}>
      <div className="accountInfo">
        <div>
          <h2 style={{ color: "#1C1154", fontWeight: "600", margin: "0" }}>Account</h2>
        </div>
        <div
          className="accountButtons"
          style={{ width: "auto", flexShrink: 0 }}
        >
          <button
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "0 15px",
              background: selectedButton === "account" ? "#2A1980" : "#FFFFFF",
              color: selectedButton === "account" ? "#FFFFFF" : "#1C1154",
              border:
              selectedButton === "account" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              marginRight: "10px",
              cursor: "pointer",
              fontWeight: selectedButton === "account" ? "normal" : "normal",
            }}
            onClick={() => handleButtonClick("account")}
          >
            Account
          </button>
          <button
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "0 15px",
              background: selectedButton === "company" ? "#2A1980" : "#FFFFFF",
              color: selectedButton === "company" ? "#FFFFFF" : "#1C1154",
              border: selectedButton === "company" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              marginRight: "10px",
              cursor: "pointer",
              fontWeight: selectedButton === "company" ? "normal" : "normal",
            }}
            onClick={() => handleButtonClick("company")}
          >
            Company
          </button>
          <button
            style={{
              height: "40px",
              minWidth: "130px",
              fontSize: "14px",
              padding: "0 15px",
              background: selectedButton === "booth" ? "#2A1980" : "#FFFFFF",
              color: selectedButton === "booth" ? "#FFFFFF" : "#1C1154",
              border: selectedButton === "booth" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: selectedButton === "booth" ? "normal" : "normal",
            }}
            onClick={() => handleButtonClick("booth")}
          >
            Book-A-Booth
          </button>
        </div>
      </div>

      {/* --- ACCOUNT INFO SECTION --- */}
      <div
        style={{
          height: "auto",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
          borderRadius: "6px",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px", marginTop: "0" }}
        >
          Account Info
        </h2>

        {/* Replaced inline flex with CSS Classes */}
        <div className="form-row">
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              First Name
            </div>
            <input
              value={formData.name}
              onChange={handleChange("name")}
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px"
              }}
            />
          </div>
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Last Name
            </div>
            <input
              value={formData.lastName}
              onChange={handleChange("lastName")}
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px"
              }}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Email
            </div>
            <input
              value={formData.email}
              onChange={handleChange("email")}
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px"
              }}
            />
          </div>
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Phone Number
            </div>
            <input
              value={formData.phone}
              onChange={handleChange("phone")}
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px"
              }}
            />
          </div>
        </div>

        {/* Verification Banner */}
        {(user && (!user.verified || user.pendingEmail)) && (
          <div
            className="verification-banner"
            style={{
              backgroundColor: "#E5E1FA",
              minHeight: "55px", 
              marginTop: "35px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "4px",
              padding: "10px 15px",
              overflow: "hidden",
              position: "relative"
            }}
          >
            <div style={{ width: "4px", position: 'absolute', left: 0, top: 0, bottom: 0, background: "#260F99" }}></div>

            <div style={{ color: "#625C73", fontSize: "16px", marginLeft: "10px", flex: 1, lineHeight: "1.4" }}>
              {user.pendingEmail ? (
                <span>
                  Verification link sent to <strong>{user.pendingEmail}</strong>. 
                  Your login remains <strong>{user.email}</strong> until verified.
                </span>
              ) : (
                "Please confirm your BoothBloom account by confirming your email account."
              )}
            </div>

            <div style={{ width: "auto" }}>
              <button
                style={{
                  height: "40px",
                  fontSize: "14px",
                  padding: "0 20px",
                  background: "#260F99",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  whiteSpace: "nowrap"
                }}
                onClick={handleResendLink}
              >
                <FaRegCircleCheck style={{ height: "14px" }} />
                Resend Link
              </button>
            </div>
          </div>
        )}

        <div style={{ marginTop: "30px", textAlign: "right" }}>
          <button
            onClick={handleSave}
            style={{
              background: "#260F99",
              color: "#fff",
              border: "none",
              padding: "10px 25px",
              fontSize: "14px",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            Save
          </button>
        </div>
      </div>

      {/* --- PASSWORD SECURITY SECTION --- */}
      <div
        style={{
          height: "auto", /* Removed hardcoded 346px */
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
          borderRadius: "6px",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px", marginTop: "0" }}
        >
          Password Security
        </h2>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Current Password
          </div>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px"
            }}
          />
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            New Password
          </div>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px"
            }}
          />
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Confirm Password
          </div>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px"
            }}
          />
        </div>
        <button
          className="action-btn"
          style={{
            marginTop: "30px",
            height: "40px",
            background: "#FFFFFF",
            border: "1px solid #D9D9D9 ",
            color: "#1C1154",
            fontSize: "15px",
            fontWeight: "450",
            cursor: "pointer",
            borderRadius: "5px"
          }}
          onClick={handleChangePassword}
        >
          Change Password
        </button>
      </div> 

      {/* --- DELETE ACCOUNT SECTION --- */}
      <div
        style={{
          height: "auto", /* Removed hardcoded 260px */
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
          borderRadius: "6px",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px", marginTop: "0" }}
        >
          Delete Account
        </h2>

        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Password
          </div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px"
            }}
          />
        </div>

        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Confirm Password
          </div>
          <input
            type="password"
            value={confirmDeletePassword}
            onChange={(e) => setConfirmDeletePassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px"
            }}
          />
        </div>

        <button
          className="action-btn"
          onClick={handleDelete}
          style={{
            marginTop: "30px",
            height: "40px",
            background: "#FFFFFF",
            border: "1px solid #D9D9D9 ",
            color: "#1C1154",
            fontSize: "15px",
            fontWeight: "450",
            cursor: "pointer",
            borderRadius: "5px"
          }}
        >
          Delete Account
        </button>
      </div>

    </div>
  );
};

export default AccountInfo;
